import { useShopifyIntegrationQuery } from '@/hooks/queries/use-integrations-query';
import type { ShopifyMetadata } from '@/types/integration';

/**
 * The currency this brand's store sells in, when we know it.
 *
 * Every plan price and every charge is denominated in it, so it is the one
 * thing a price on screen has to agree with. Read from the connected Shopify
 * integration rather than from the subscription, because a brand about to buy
 * its first plan has a store but no subscription yet, and quoting two different
 * sources on two screens is how the paywall and the settings page start
 * disagreeing about what the same plan costs.
 *
 * Undefined has one meaning and one only: we have not asked this store yet. The
 * API then prices in its own fallback, and callers pass this straight through
 * instead of substituting a currency of their own, so a single place decides
 * what an unknown store is billed in.
 */
export function useShopCurrency(options: { enabled?: boolean } = {}): string | undefined {
  const { data: shopifyIntegration } = useShopifyIntegrationQuery(options);

  return (shopifyIntegration?.metadata as ShopifyMetadata | undefined)?.shopCurrency;
}
